// Globally register all base components for convenience, because they
// will be used very frequently. Components are registered using the
// PascalCased version of their file name.

import Vue from 'vue';
import VSnackbarQueue from './VSnackbarQueue.vue';

// Globally register the component
Vue.component('VSnackbarQueue', VSnackbarQueue);
